<template>
	<div class="campaign-party-control">
		<scoped-bus name="CampaignPartyDialog">
			<row-object-dialog :oref="oref" v-model="cp"></row-object-dialog>
		</scoped-bus>
	</div>
	<virtual-route v-if="cp?.party" path="/editParty.do" :id="cp.party">
		<party-page></party-page>
	</virtual-route>
</template>

<script setup lang="ts">
import VirtualRoute from "@/router/virtual/VirtualRoute.vue";
import PartyPage from "@/pages/addressbook/PartyPage.vue";
import {connectEventBus} from "@fd/Environment.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import {useVirtualRoute} from "@/router/virtual/VirtualRouter.ts";
import {ref} from "vue";
import {objectRef, RowObjectInit, RowObjectRef, RowObjectType, SrcType} from "@t/meta/SourceType.ts";
import {CampaignParty} from "@t/marketing/CampaignParty.ts";
import RowObjectDialog from "@/pages/row-object/RowObjectDialog.vue";
import ScopedBus from "@/router/virtual/ScopedBus.vue";

const bus = connectEventBus("CampaignPartyPage");
const ns = useNavigationStore();
const route = useVirtualRoute();
const cp = ref<CampaignParty>(null);
const oref = objectRef(route, SrcType.CAMPAIGN_PARTY);

ns.listenForStackerUpdates(bus, oref, () => "unsupported",
	"/editCampaignParty.do", () => cp.value.partyName, () => cp.value.id);

</script>

<style>
.campaign-party-control:not(:empty) {
	margin-bottom: var(--gap-l);
}
</style>